import { createContext, useContext } from 'react';
import type { AppLocale } from './locale-storage';

export type ActivateLocale = (locale: AppLocale) => Promise<void>;

/**
 * El contexto y su hook van acá y el provider en `locale-activation.tsx` por
 * `react-refresh/only-export-components`: un archivo que exporta un componente no exporta hooks.
 */
export const LocaleActivationContext = createContext<ActivateLocale | null>(null);

export function useLocaleActivation(): ActivateLocale {
  const activate = useContext(LocaleActivationContext);
  if (!activate) throw new Error('useLocaleActivation necesita un LocaleActivationProvider');
  return activate;
}
